import { Skeleton } from "@/components/ui/skeleton";

export function FullPageSpinner({ label = "Loading" }) {
  return (
    <div
      className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-8"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="flex w-full max-w-sm flex-col gap-3">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="mt-2 h-32 w-full" />
      </div>
      <p className="text-sm text-muted-foreground">{label}…</p>
    </div>
  );
}
